import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyIndicator'
})
export class EmptyIndicatorPipe implements PipeTransform {

  transform(value: any, title?: string): any {
    if (!value) {
      return title ? title : '-';
    }
    return value;
  }

}
